import React from 'react'
import _ from 'lodash/fp'

import colors from '@fe/ui/colors'
import { getClubImage, getClubLogo } from '../../config'

// Material UI things
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'

import {
  LocationOn as Location
} from '@material-ui/icons'

import { parseDistance, haversineDistance } from '../../util/map'

export class Club extends React.Component {
  render () {
    const height = 100
    const spacing = 0
    const { club, sorting, position } = this.props
    const customer = _.get('customer', club)
    const logoUrl = getClubLogo(_.get('id', club))
    const imageUrl = getClubImage(_.flow(
      _.get('gallery_file_names'),
      _.first
    )(club))
    return (
      <Paper style={{ width: '100%' }}>
        <Grid container spacing={spacing}>
          <Grid item xs={4} md={2}>
            <div
              style={{
                backgroundImage: customer ? `url(${imageUrl})` : '',
                backgroundColor: customer ? colors.primaryDarkGreen : colors.paleGreen,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '100%',
                width: '100%'
              }}
            />
          </Grid>
          <Grid item xs={8} md={10} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div
              style={{
                backgroundImage: customer ? `url(${logoUrl})` : '',
                backgroundColor: colors.white,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: height,
                width: height,
                borderRadius: '50%',
                position: 'relative',
                left: `-${(height / 2) + spacing}px`
              }}
            />
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'flex-start' }}>
              <div>{_.get('name', club)}</div>
              <div>{_.get('address.street', club)}</div>
              <div>{`${_.get('address.city', club)}, ${_.get('address.country_code', club)}`}</div>
            </div>
            {sorting === 'position' && position && (
              <div style={{ paddingRight: 12 }}>
                <Location />
                {`${parseDistance(haversineDistance(position, _.get('position', club)))}`}
              </div>
            )}
          </Grid>
        </Grid>
      </Paper>
    )
  }
}

export class ClubsList extends React.Component {
  render () {
    const { barHeight, clubs, sorting, position, classes } = this.props
    return (
      <div style={{ marginTop: barHeight }}>
        <List>
          {_.map((club) => (
            <ListItem dense key={_.get('id', club)} onClick={() => { console.log('nothing yet') }}>
              <Club
                classes={classes}
                sorting={_.flow(_.get('value'), _.first)(sorting)}
                position={position}
                club={club}
              />
            </ListItem>
          ), clubs)}
        </List>
      </div>
    )
  }
}
